<template>
    <internal>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <div class="flex items-center justify-end space-x-8 text-base">
                <div class="flex flex-row space-x-2 py-2">
                    <div class="w-6 h-6 flex items-end justify-center">
                        <span class="w-1.5 h-1.5 rounded-full" style="background:#3182ce"></span>
                    </div>
                    <div>Present</div>
                </div>
                <div class="flex flex-row space-x-2 py-2">
                    <div class="w-6 h-6 rounded-full" style="border:2px solid #c53030"></div>
                    <div>Absent</div>
                </div>
                <div class="flex flex-row space-x-2 py-2">
                    <div class="w-6 h-6 rounded-full" style="background:#bee3f8"></div>
                    <div>Holiday</div>
                </div>
            </div>
            <v-calendar :attributes='attrs' is-expanded />
        </div>
    </internal>
</template>

<script>
    import Internal from '@/Pages/Internal/Internal'
    import ButtonLink from '@/Components/ButtonLink'

    export default {
        components: {
            Internal,
            ButtonLink,
        },
        props:['presents','absents','holidays'],
        data(){
            return{
                branchid:localStorage.branchId,
                attrs: [
                    {
                    key: 'today',
                    highlight: {
                        color: 'red',
                        fillMode: 'outline',
                    }, //absent
                    dates: new Date(),
                    },
                ],
            }
        },
        beforeMount(){
            this.presents.forEach((pr) => {
                this.attrs.push({
                    key:pr.id,
                    dot: true,
                    dates: new Date(pr.attendance_at)
                })
            })
            this.absents.forEach((ab) => {
                this.attrs.push({
                    key:ab.id,
                    highlight: {
                        color: 'red',
                        fillMode: 'outline',
                    },
                    dates: new Date(ab.attendance_at)
                })
            })
            this.holidays.forEach((hl) => {
                this.attrs.push({
                    key:hl.id,
                    highlight: {
                        color: 'blue',
                        fillMode: 'light',
                    },
                    popover:{
                        label:hl.title
                    },
                    dates: hl.to_date?{start: new Date(hl.from_date),end:new Date(hl.to_date)}:new Date(hl.from_date)
                })
            })
        }
    }
</script>
